import * as React from 'react';
import SettingBoxLayout, {
    SettingBox,
    SettingHeader,
    SettingBody,
    SettingFooter,
    SettingGroupRow,
    SettingGroup
} from '../settingsBox/SettingBox';
import Select from 'react-select';
import * as optionSettings from '../../../../../mapping/optionSettings';
import IndicatorsContainer from '../../../../common/reactSelect/IndicatorsContainer';

import Toggle from '../../../../common/Toggle';

export interface IOptionSettings {
    isTypeScale?: boolean;
    showOptionsInARow?: boolean;
    showOptionsLayout?: boolean;
    showOptionType?: boolean;
    showCardType?: boolean;
    showImageDisplay?: boolean;
    showOptionNotApplicable?: boolean;
    showRandomizeOption?: boolean;
    showAliginOption?: boolean;
    showMinMax?: boolean;
    showPipingOptions?: boolean;
    showIsEnableRichText?: boolean;
}

interface IOptionSettingsProps {
    setValue: (keyName: string, value: any) => void;
    question: any;
    settings?: IOptionSettings;
    toggleOptionSettings: () => void;
    onSaveOptionSettings: () => void;
    handleInputChange?: (event) => void;
    setSelectedValue?: (keyName: string, value: any) => void;
    optionSettingErrors?: any;
    disabled: boolean;
}

const OptionSettings: React.SFC<IOptionSettingsProps> = ({
    toggleOptionSettings,
    onSaveOptionSettings,
    settings,
    question,
    setValue,
    setSelectedValue,
    handleInputChange,
    optionSettingErrors,
    disabled
}) => {
    optionSettingErrors = optionSettingErrors || {};
    const {
        optionsLayout,
        optionType,
        imageDisplay,
        optionNotApplicable,
        randomizeOption,
        aliginOption,
        min,
        max,
        showNotApplicableOption,
        random,
        selectedAlignOption,
        piping,
        selectedOptionType,
        isRichText,
        popupSettings
    } = question;
    const {
        showOptionsInARow,
        isTypeScale,
        showOptionsLayout,
        showOptionType,
        showCardType,
        showImageDisplay,
        showOptionNotApplicable,
        showRandomizeOption,
        showAliginOption,
        showMinMax,
        showPipingOptions,
        showIsEnableRichText
    } = settings;
    const oir = [
        {
            label: optionsLayout,
            value: optionsLayout
        }
    ];

    const oType = [
        {
            label: optionSettings.optionTypeMapping[selectedOptionType],
            value: selectedOptionType
        }
    ];

    const cType = [
        {
            label:
                optionSettings.popupCardOptionMapping[
                    popupSettings?.popupCardTypes
                ],
            value: popupSettings?.popupCardTypes
        }
    ];

    const imgDisplay = [
        {
            label: optionSettings.imgDisplayMapping[imageDisplay],
            value: imageDisplay
        }
    ];
    const oAlign = [
        {
            label: optionSettings.oAlignMapping[selectedAlignOption],
            value: selectedAlignOption
        }
    ];
    return (
        <SettingBox>
            <SettingHeader
                title={`${isTypeScale ? 'Scale' : 'Option'} settings`}
                onClose={toggleOptionSettings}
                hasError={optionSettingErrors.number ? true : false}
            />
            <SettingBody>
                <div
                    className={
                        optionSettingErrors && optionSettingErrors.number
                            ? 'setting-group-row range-select error'
                            : 'setting-group-row range-select'
                    }
                >
                    {(showOptionsInARow && (
                        <SettingGroup label="Option displayed in a row">
                            <Select
                                className="react-select"
                                classNamePrefix="react-select"
                                name="form-field-name"
                                placeholder="Option count"
                                value={oir ? oir : null}
                                onChange={(value) =>
                                    setValue('optionsLayout', value.value)
                                }
                                menuIsopen={true}
                                options={optionSettings.optionDisplayedInRow}
                                components={{
                                    IndicatorsContainer
                                }}
                                isDisabled={disabled}
                            />
                        </SettingGroup>
                    )) ||
                        null}

                    {(showMinMax && (
                        <SettingGroup label="Number of options to select">
                            <div className="range-label">
                                <label>Min</label>
                                <input
                                    type="number" //Keep validation here
                                    className="form-group__control opt-min"
                                    placeholder="Min"
                                    onChange={(event) =>
                                        setValue(
                                            'min',
                                            parseInt(event.target.value)
                                        )
                                    }
                                    value={min}
                                    name="min"
                                    min="0"
                                    disabled={disabled}
                                />
                            </div>
                            <span className="dash"> - </span>
                            <div className="range-label">
                                <label>Max</label>
                                <input
                                    type="number"
                                    className="form-group__control opt-max"
                                    placeholder="Max"
                                    onChange={(event) => {
                                        setValue(
                                            'max',
                                            parseInt(event.target.value)
                                        );
                                    }}
                                    value={max}
                                    name="max"
                                    min="0"
                                    disabled={disabled}
                                />
                            </div>
                            {optionSettingErrors && optionSettingErrors.number
                                ? optionSettingErrors.number
                                : ''}
                        </SettingGroup>
                    )) ||
                        null}
                </div>

                {(showOptionType && (
                    <SettingGroupRow>
                        <SettingGroup
                            label={isTypeScale ? 'Scale type' : 'Option type'}
                        >
                            <Select
                                className="react-select"
                                classNamePrefix="react-select"
                                name="form-field-name"
                                placeholder={
                                    isTypeScale ? 'Scale type' : 'Option type'
                                }
                                value={oType ? oType : null}
                                onChange={(value) =>
                                    setValue('selectedOptionType', value.value)
                                }
                                options={optionSettings.optionType}
                                components={{
                                    IndicatorsContainer
                                }}
                                isDisabled={disabled}
                            />
                        </SettingGroup>
                        {selectedOptionType == 'imageOnly' ||
                        selectedOptionType == 'imageAndText' ? (
                            <SettingGroup label="Image display">
                                <Select
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    name="form-field-name"
                                    placeholder="Image display"
                                    value={imgDisplay ? imgDisplay : null}
                                    onChange={(value) =>
                                        setValue('imageDisplay', value.value)
                                    }
                                    options={optionSettings.imageDisplay}
                                    components={{
                                        IndicatorsContainer
                                    }}
                                    isDisabled={disabled}
                                />
                            </SettingGroup>
                        ) : null}
                    </SettingGroupRow>
                )) ||
                    null}
                {(showCardType && (
                    <SettingGroupRow>
                        <SettingGroup label="Card type">
                            <Select
                                className="react-select"
                                classNamePrefix="react-select"
                                name="form-field-name"
                                placeholder="Card type"
                                value={cType ? cType : null}
                                onChange={(value) =>
                                    setValue('popupCardTypes', value.value)
                                }
                                options={optionSettings.popupCardType}
                                components={{
                                    IndicatorsContainer
                                }}
                                isDisabled={disabled}
                            />
                        </SettingGroup>
                        {/* {popupSettings?.popupCardTypes == 'imageOnly' ||
                        popupSettings?.popupCardTypes == 'imageAndText' ? (
                            <SettingGroup label="Image display">
                                <Select
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    name="form-field-name"
                                    placeholder="Image display"
                                    value={imgDisplay ? imgDisplay : null}
                                    onChange={(value) =>
                                        setValue('imageDisplay', value.value)
                                    }
                                    options={optionSettings.imageDisplay}
                                    components={{
                                        IndicatorsContainer
                                    }}
                                    isDisabled={disabled}
                                />
                            </SettingGroup>
                        ) : null} */}
                    </SettingGroupRow>
                )) ||
                    null}
                {(showIsEnableRichText && (
                    <SettingGroupRow>
                        <SettingGroup label="Enable rich text">
                            <Toggle
                                onChange={(value) =>
                                    setValue('isRichText', value)
                                }
                                checked={isRichText}
                                disabled={disabled}
                            />
                        </SettingGroup>
                    </SettingGroupRow>
                )) ||
                    null}
                {((showOptionNotApplicable || showRandomizeOption) && (
                    <SettingGroupRow>
                        {(showOptionNotApplicable && (
                            <SettingGroup label="Show not applicable option">
                                <Toggle
                                    onChange={(value) =>
                                        setValue(
                                            'showNotApplicableOption',
                                            value
                                        )
                                    }
                                    checked={showNotApplicableOption}
                                    disabled={disabled}
                                />
                            </SettingGroup>
                        )) ||
                            null}
                        {(showRandomizeOption && (
                            <SettingGroup label="Randomize the options">
                                <Toggle
                                    onChange={(value) =>
                                        setValue('random', value)
                                    }
                                    checked={random}
                                    disabled={disabled}
                                />
                            </SettingGroup>
                        )) ||
                            null}
                    </SettingGroupRow>
                )) ||
                    null}

                {((showAliginOption || showPipingOptions) && (
                    <SettingGroupRow>
                        {(showAliginOption && (
                            <SettingGroup label="Align options">
                                <Select
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    name="form-field-name"
                                    placeholder="Align options"
                                    value={oAlign}
                                    onChange={(value) =>
                                        setValue(
                                            'selectedAlignOption',
                                            value.value
                                        )
                                    }
                                    options={optionSettings.alignOptions}
                                    components={{
                                        IndicatorsContainer
                                    }}
                                    isDisabled={disabled}
                                />
                            </SettingGroup>
                        )) ||
                            null}
                        {(showPipingOptions && (
                            <SettingGroup label="Pipe options from previous question">
                                <Toggle
                                    onChange={(value) =>
                                        setValue('piping', value)
                                    }
                                    checked={piping}
                                    disabled={disabled}
                                />
                            </SettingGroup>
                        )) ||
                            null}
                    </SettingGroupRow>
                )) ||
                    null}
            </SettingBody>
            <SettingFooter>
                <div className="actions">
                    <button
                        disabled={optionSettingErrors.number ? true : false}
                        className="btn btn--sm btn--transparent m-r-10"
                        onClick={toggleOptionSettings}
                    >
                        Cancel
                    </button>
                    <button
                        // disabled={optionSettingErrors.number ? true : false}
                        className="btn btn--sm btn--green"
                        onClick={onSaveOptionSettings}
                        disabled={disabled}
                    >
                        Done
                    </button>
                </div>
            </SettingFooter>
        </SettingBox>
    );
};

export default OptionSettings;
